
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2015-01-06-first-snowfall-of-the-winter",
      function () {
        return require("private-next-pages/posts/2015-01-06-first-snowfall-of-the-winter.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2015-01-06-first-snowfall-of-the-winter"])
      });
    }
  